/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithOrderItemRequestBuilder, WithOrderItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/order-summary
 */
export interface OrderSummaryRequestBuilder extends BaseRequestBuilder<OrderSummaryRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.invoices.orderSummary.item collection
     * @param orderId Unique identifier of the item
     * @returns {WithOrderItemRequestBuilder}
     */
     byOrderId(orderId: string) : WithOrderItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const OrderSummaryRequestBuilderUriTemplate = "{+baseurl}/api/invoices/order-summary";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrderSummaryRequestBuilderNavigationMetadata: Record<Exclude<keyof OrderSummaryRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byOrderId: {
        requestsMetadata: WithOrderItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["orderId"],
    },
};
/* tslint:enable */
/* eslint-enable */
